import { render, staticRenderFns } from "./TheInstanceDeleteDialog.vue?vue&type=template&id=b927c96a&"
import script from "./TheInstanceDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./TheInstanceDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports